import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';




export default class YouLose extends React.Component {
    render() {

        let question_plural = "questions";

        if(this.props.dodged == 1)
        {
            question_plural = "question";
        }

        return (
        
              <header className="App-header">
                      
                    
              <h2>{this.props.fail_message} </h2>
              <p>You dodged {this.props.dodged} devious {question_plural}.</p>
            
  
            </header>
      
        )
    }
  }
  
